/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Career_3Inputs */

const en_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michigan State men's golf (1976-1977)`)
};

const es_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf masculino de Michigan State (1976-1977)`)
};

const de_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michigan State Herrengolf (1976–1977)`)
};

const zh_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密歇根州立大学男子高尔夫（1976-1977）`)
};

const ar_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غولف الرجال في Michigan State (1976-1977)`)
};

const fr_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf masculin de Michigan State (1976-1977)`)
};

const vi_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội golf nam Michigan State (1976-1977)`)
};

const sw_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gofu ya wanaume, Michigan State (1976-1977)`)
};

const th_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีมกอล์ฟชาย Michigan State (1976-1977)`)
};

const bs_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muški golf Michigan State (1976-1977)`)
};

const ja_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミシガン州立大学男子ゴルフ部（1976–1977年）`)
};

const ko_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미시간 주 남자 골프 (1976-1977)`)
};

const pt_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipe masculina de golfe de Michigan State (1976-1977)`)
};

const it_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf maschile di Michigan State (1976-1977)`)
};

const sv_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michigan State, herrgolf (1976-1977)`)
};

const nl_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herengolfteam van Michigan State (1976-1977)`)
};

const da_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michigan State, herregolf (1976-1977)`)
};

const nb_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michigan State, herregolf (1976-1977)`)
};

const fi_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michigan Staten miesten golf (1976-1977)`)
};

const pl_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf mężczyzn, Michigan State (1976-1977)`)
};

const ru_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мужская команда по гольфу Michigan State (1976-1977)`)
};

const tr_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michigan State erkek golf takımı (1976-1977)`)
};

const hi_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michigan State पुरुष गोल्फ (1976-1977)`)
};

const id_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim golf putra Michigan State (1976-1977)`)
};

const ms_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan golf lelaki Michigan State (1976-1977)`)
};

const cs_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pánský golf, Michigan State (1976-1977)`)
};

const el_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανδρικό γκολφ, Michigan State (1976-1977)`)
};

const he_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גולף גברים, Michigan State (1976-1977)`)
};

const af_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michigan State mannengolf (1976-1977)`)
};

const hu_about_content_career_3 = /** @type {(inputs: About_Content_Career_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michigan State férfi golfcsapat (1976-1977)`)
};

/**
* | output |
* | --- |
* | "Michigan State men's golf (1976-1977)" |
*
* @param {About_Content_Career_3Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_career_3 = /** @type {((inputs?: About_Content_Career_3Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Career_3Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_career_3(inputs)
	if (locale === "de") return de_about_content_career_3(inputs)
	if (locale === "zh") return zh_about_content_career_3(inputs)
	if (locale === "ar") return ar_about_content_career_3(inputs)
	if (locale === "fr") return fr_about_content_career_3(inputs)
	if (locale === "vi") return vi_about_content_career_3(inputs)
	if (locale === "sw") return sw_about_content_career_3(inputs)
	if (locale === "th") return th_about_content_career_3(inputs)
	if (locale === "bs") return bs_about_content_career_3(inputs)
	if (locale === "ja") return ja_about_content_career_3(inputs)
	if (locale === "ko") return ko_about_content_career_3(inputs)
	if (locale === "pt") return pt_about_content_career_3(inputs)
	if (locale === "it") return it_about_content_career_3(inputs)
	if (locale === "sv") return sv_about_content_career_3(inputs)
	if (locale === "nl") return nl_about_content_career_3(inputs)
	if (locale === "da") return da_about_content_career_3(inputs)
	if (locale === "nb") return nb_about_content_career_3(inputs)
	if (locale === "fi") return fi_about_content_career_3(inputs)
	if (locale === "pl") return pl_about_content_career_3(inputs)
	if (locale === "ru") return ru_about_content_career_3(inputs)
	if (locale === "tr") return tr_about_content_career_3(inputs)
	if (locale === "hi") return hi_about_content_career_3(inputs)
	if (locale === "id") return id_about_content_career_3(inputs)
	if (locale === "ms") return ms_about_content_career_3(inputs)
	if (locale === "cs") return cs_about_content_career_3(inputs)
	if (locale === "el") return el_about_content_career_3(inputs)
	if (locale === "he") return he_about_content_career_3(inputs)
	if (locale === "af") return af_about_content_career_3(inputs)
	if (locale === "hu") return hu_about_content_career_3(inputs)
	return en_about_content_career_3(inputs)
});